import React, { useState, useEffect } from "react";
import Moment from "react-moment";
import { FaRegEdit, FaFileImage } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Services } from "Services";
import { warningSwal } from "Util/Toast";
import SkeletonLoad from "Components/TableLoad/load";
import CommonClasses from "Styles/Common.module.css";
import { Helmet } from "react-helmet";
import Layout from "Components/Layout";
import { BiPlus } from "react-icons/bi";
import { TablePagination } from "@mui/material";
import UserClasses from '../users/Users.module.css';

function Templates() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [templateCategories, setTemplateCategories] = useState([]);
    const [selectedTemplateCategory, setSelectedTemplateCategory] = useState("");
    const [imageErrors, setImageErrors] = useState({});
    const token = { Authorization: `token ${localStorage.getItem("token")}` };

    const fetchTemplateCategories = () => {
        Services.getTemplateCategories("POST", null, token)
            .then((response) => {
                if (response.Status === 1) {
                    setTemplateCategories(response.TemplateCategories);
                }
            })
            .catch((err) => {
                console.error("Error fetching template categories:", err);
            });
    };

    const fetchTemplates = (templateCategoryId = null) => {
        setLoading(true);
        const body = templateCategoryId ? JSON.stringify({ TemplateCategoryID: templateCategoryId }) : null;
        Services.getTemplates("POST", body, token)
            .then((response) => {
                setLoading(false);
                if (response.Status === 1) {
                    setData(response.Templates);
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                alert("Something went wrong. Please try again.");
                console.error(err);
            });
    };

    useEffect(() => {
        fetchTemplateCategories();
    }, []);

    useEffect(() => {
        fetchTemplates(selectedTemplateCategory || null);
    }, [selectedTemplateCategory]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleTemplateCategoryChange = (event) => {
        setSelectedTemplateCategory(event.target.value);
        setPage(0); // Reset to first page when filter changes
    };

    const handleImageError = (templateId) => {
        setImageErrors(prev => ({
            ...prev,
            [templateId]: true
        }));
    };

    return (
        <Layout Active={"Templates"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Templates</title>
            </Helmet>
            <div className={CommonClasses["Container"]}>
                <div>
                    <h1 style={{ color: '#FF0D0D' }}>TEMPLATES</h1>
                </div>
                <div className={CommonClasses["control-btns"]}>
                    <button
                        className={CommonClasses["button"]}
                        onClick={() => {
                            navigate("/addtemplate");
                        }}
                    >
                        <BiPlus size={20} /> Create New Template
                    </button>
                    <div style={{ marginLeft: '20px' }}>
                        <select
                            value={selectedTemplateCategory}
                            onChange={handleTemplateCategoryChange}
                            style={{
                                padding: '8px 12px',
                                borderRadius: '4px',
                                border: '1px solid #ddd',
                                fontSize: '14px',
                                minWidth: '200px'
                            }}
                        >
                            <option value="">All Template Categories</option>
                            {templateCategories.map((category) => (
                                <option key={category.TemplateCategoryId} value={category.TemplateCategoryId}>
                                    {category.TemplateCategoryName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className={CommonClasses["wrapper"]}>
                    {loading ? (
                        <SkeletonLoad
                            TableHead={[
                                "TemplateImage",
                                "TemplateName",
                                "CreatedAt",
                                "UpdatedAt",
                                "TemplateStatus",
                                "Actions",
                            ]}
                        />
                    ) : data.length > 0 ? (
                        <div className={CommonClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>TemplateImage</th>
                                        <th>TemplateName</th>
                                        <th>CreatedAt</th>
                                        <th>UpdatedAt</th>
                                        <th>TemplateStatus</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data
                                        .slice(
                                            page * rowsPerPage,
                                            page * rowsPerPage + rowsPerPage
                                        )
                                        .map((item) => (
                                            <tr
                                                key={item.TemplateID}
                                                id={item.TemplateID}
                                                name={item.TemplateName}
                                                // onClick={() =>
                                                //     navigate(
                                                //         `/bannerdetails/${item.TemplateID}`
                                                //     )
                                                // }
                                                style={{ cursor: "pointer" }}
                                            >
                                                <td style={{ padding: '8px', textAlign: 'center', verticalAlign: 'middle' }}>
                                                    {(!item.Template || imageErrors[item.TemplateID]) ? (
                                                        <div
                                                            style={{
                                                                width: "10rem",
                                                                height: "5rem",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                backgroundColor: "#f0f0f0",
                                                                borderRadius: "5px",
                                                                border: "2px solid #ddd",
                                                                margin: "0 auto"
                                                            }}
                                                        >
                                                            <FaFileImage size={40} color="#999" />
                                                        </div>
                                                    ) : (
                                                        <img
                                                            style={{
                                                                width: "10rem",
                                                                height: "5rem",
                                                                objectFit: "cover",
                                                                borderRadius: "5px",
                                                                display: "block",
                                                                margin: "0 auto"
                                                            }}
                                                            src={item.Template}
                                                            alt="Template-img"
                                                            onError={() => handleImageError(item.TemplateID)}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                window.open(
                                                                    item.Template,
                                                                    "_blank"
                                                                );
                                                            }}
                                                        />
                                                    )}
                                                </td>
                                                <td>{item.TemplateName}</td>
                                                <td>
                                                    <Moment format="DD-MM-YYYY">
                                                        {item.CreatedAt}
                                                    </Moment>
                                                </td>
                                                <td>
                                                    <Moment format="DD-MM-YYYY">
                                                        {item.UpdateAt}
                                                    </Moment>
                                                </td>
                                                <td>
                                                    {item.TemplateStatus ===
                                                        1 ? (
                                                        <div
                                                            className={
                                                                CommonClasses[
                                                                "Status-active"
                                                                ]
                                                            }
                                                        >
                                                            <span>Active</span>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className={
                                                                CommonClasses[
                                                                "Status-inactive"
                                                                ]
                                                            }
                                                        >
                                                            <span>
                                                                Inactive
                                                            </span>
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <div
                                                        className={
                                                            CommonClasses[
                                                            "Action-btns"
                                                            ]
                                                        }
                                                    >
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                navigate(
                                                                    `/updatetemplate/${item.TemplateID}`,
                                                                    {
                                                                        state: {
                                                                            template: item,
                                                                        },
                                                                    }
                                                                );
                                                            }}
                                                        >
                                                            <FaRegEdit />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div>
                            <p>No Templates Found</p>
                        </div>
                    )}
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        className={CommonClasses["pagination"]}
                    />
                </div>
            </div>
        </Layout>
    );
}

export default Templates;
